import React, { useContext } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import './About.sass'
import Button from '../../ui/Button/Button'
import bgImage from './about.jpg'
import { AuthContext } from '../../App'
import Icon from '../../ui/Icon/Icon'

function About() {
  const { contacts, setShowContactUs } = useContext(AuthContext)

  const benefits = [
    {
      title: 'Швидке оформлення замовлення',
      description: `Додатковий опис`,
      icon: 'shipping-fast',
    },
    {
      title: 'Оптимальні ціни',
      description: 'Додатковий опис',
      icon: 'money-bill-wave',
    },
    {
      title: 'Всі необхідні дозвільні документи',
      description: 'Додатковий опис',
      icon: 'file-check',
    },
    {
      title: 'Партнерські бонуси',
      description: 'Додатковий опис',
      icon: 'coins',
    },
  ]
  return (
    <section id="about" name="about" class="About">
      <div className="AboutImg">
        <img src={bgImage} alt="Gusto" />
      </div>
      <div className="DefaultContainer">
        <SectionTitle title="Про компанію" />
        <div class="About-Container">
          <div class="About-Text">
            {/* <p>Наша компанія</p> */}
            <div className="Benefits-Container">
              {benefits.map((b) => (
                <div className="BenefitTile">
                  <Icon name={b.icon} weight="solid" />
                  <div className="Text">
                    <p className="Title">{b.title}</p>
                    {/* <p className="Description">{b.description}</p> */}
                  </div>
                </div>
              ))}
            </div>

            <Button
              title="Замовити дзвінок"
              type="button"
              icon="phone"
              iconWeight="solid"
              onClick={() =>
                setShowContactUs({
                  show: true,
                  title: 'Замовити дзвінок',
                  emailSubject: 'Запит на консультацію',
                })
              }
              // onClick={() => (window.location.href = `tel:${contacts.phone}`)}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
